import { Navigate, RouteObject } from "react-router-dom";
import FednowCaseContainer from "../../components/fednow_manager/FednowCaseContainer";
import FednowPaymentContainer from "../../components/fednow_manager/FednowPaymentContainer";
import FednowDelinedContainer from "@components/fednow_manager/FednowDeclinedContainer";
import { TopBarPageContainer } from "../../components/PageContainer";

export const FEDNOW_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="/fednow/cases" />,
  },
  {
    path: "cases/:id?",
    element: (
      <TopBarPageContainer title="FedNow Manager">
        <FednowCaseContainer />
      </TopBarPageContainer>
    ),
  },
  {
    path: "payments/:id?",
    element: (
      <TopBarPageContainer title="FedNow Manager">
        <FednowPaymentContainer />
      </TopBarPageContainer>
    ),
  },
  {
    path: "declined/:id?",
    element: (
      <TopBarPageContainer title="FedNow Manager">
        <FednowDelinedContainer />
      </TopBarPageContainer>
    ),
  },
];
